import * as React from "react"
import * as _ from "lodash"
import IMealItem from "../../../models/IMealItem"
import TextInput from "../../TextInput";
import AppLoader from "../../utils/AppLoader";
import LocalStorageUtils from "../../../utils/LocalStorageUtils";
import CustomHeader from "../../utils/CustomHeader";
import {customMealBuilderComponentsHeaderInfos} from "../../../containers/CustomMealBuilderContainer";
import HorizontalTagsListView from "../../HorizontalTagsListView";
import DishAdder from "../../DishAdder";
import IDishCatalogueResponse from "../../../models/maverick/IDishCatalogueResponse";
import {IDietRecallFoodOptionValue} from "../../../models/IDietRecallMealItem";
import {default as AppUtils, LOADING_STATE} from "../../../utils/AppUtils";
import {IMealComponent} from "../../../../../server/models/UIModels/userPlan/commons/IMealOption";
import {SUB_SECTIONS_CONTEXT_KEY} from "../../../utils/AppConstants";


export interface MealItemEditorProps {
    mealId?: string;
    mealItem?: IMealItem;
    onMealRemove: (mealId: string) => void;
    fetchMealByMealId: (mealId: string) => Promise<IMealItem>;
    mealSlot: string;
    addMeal: (meal: IMealItem) => void;
    createMeal: (meal: IMealItem) => Promise<IMealItem>;
    fetchStaticDishes: (input: string) => Promise<IDishCatalogueResponse[]>;
    suggestions: {[key: string]: any}
}

export interface MealItemEditorState {
    meal: IMealItem;
    isEditable: boolean;
    isSaving: boolean;
    addedComponents: IMealComponent[]
}

class MealItemEditor extends React.Component<MealItemEditorProps, MealItemEditorState> {
    constructor(props: MealItemEditorProps) {
        super(props);
        this.state = {
            meal: null,
            isEditable: false,
            isSaving: false,
            addedComponents: []
        }
    }
    componentDidMount() {
        let meal = LocalStorageUtils.getMealFromMealId(this.props.mealId);
        if (!_.isEmpty(meal)) {
            this.setState({
                meal,
                addedComponents: meal.components || []
            })
        } else {
            this.props.fetchMealByMealId(this.props.mealId).then((meal: IMealItem) => {
                this.setState({
                    meal,
                    addedComponents: meal.components || []
                })
            })
        }
    }
    removeMeal = () => {
        let mealId = this.props.mealId;
        this.props.onMealRemove(mealId);
    }

    handleEdit = () => {
        if (!_.isEmpty(this.state.addedComponents)) {
            this.setState({
                isEditable: true
            })
        } else {
            this.setState({
                isEditable: true,
                addedComponents: this.state.meal.components
            })
        }
    };

    handleCancel = () => {
        this.setState({
            addedComponents: [],
            isEditable: false
        })
    }

    removeDish = (dishId: string) => {
        const dishes = [...this.state.addedComponents].filter((component) => component.dishId !== dishId);
        this.setState({ addedComponents: dishes })
    }

    editDishQuantity = (event: any, dishId: string) => {
        const updatedDishes = [...this.state.addedComponents].map((component) => {
            if (component.dishId === dishId) {
                component.quantity = event.target.value;
            }
            return component;
        });
        this.setState({ addedComponents: updatedDishes })
    }

    addDish = (dish: IDietRecallFoodOptionValue) => {
        let formattedDish: IMealComponent = {
            dishId: dish.id,
            displayName: dish.name,
            quantity: dish.count,
            unit: dish.unit
        }
        // let mealComponents = !_.isEmpty(this.state.meal.components) ? this.state.meal.components : [];
        // let updatedMeal = { ...this.state.meal, components: [ ...mealComponents, formattedDish ] };
        // this.setState({meal: updatedMeal})
        const updatedComponents = [...this.state.addedComponents]
        updatedComponents.push(formattedDish);
        this.setState({
            addedComponents: updatedComponents
        })
    }

    saveMeal = () => {
        let meal = {...this.state.meal};
        meal.shortDescription = "-";
        meal.detailedDescription = "-";
        meal.status = "UNAPPROVED";
        meal.source = "DOCSAPP";
        meal.components = [...this.state.addedComponents]
        if ( meal.version !== undefined ) delete meal.version;
        if (AppUtils.isDefined(meal.mealId)) delete meal.mealId;
        meal.mealSlots = [this.props.mealSlot];
        this.setState({
            isSaving: true
        }, () => {
            this.props.createMeal(meal).then((newMeal) => {
                this.removeMeal();
                this.props.addMeal(newMeal);
                LocalStorageUtils.addMealToMap(newMeal)
                this.setState({
                    isSaving: false,
                    isEditable: false,
                    // meal: newMeal,
                    addedComponents: []
                })
            }).catch((err) => {
                // this.setState({
                //     mealSaveError: "Could not save meals",
                //     mealSaveLoadingStatus: LOADING_STATE.LOADED
                // })
            })
        })
    }

    handleSave = () => {
        if (_.isEmpty(this.state.addedComponents)) {
            this.removeMeal()
        } else {
            this.saveMeal()
        }
    }

    getSuggestions = () => {
        let updatedDish = this.state.addedComponents ? this.state.addedComponents : [];
        let mealSlot = this.props.mealSlot.toLowerCase();
        if (!_.isEmpty(this.props.suggestions) && !_.isEmpty(this.props.suggestions[`meals-${mealSlot}`])) {
            const suggestions = this.props.suggestions[`meals-${mealSlot}`];
            if (updatedDish && updatedDish.length) {
                const alreadyFilledItems = updatedDish.map(dish => { return dish.displayName });
                return suggestions.filter((item: any) => !_.isEmpty(alreadyFilledItems) && alreadyFilledItems.indexOf(item.recommendation.displayName) < 0);
            }
            return suggestions;
        }
        return [];
    }

    render() {
        let mealItem = this.state.meal;
        const { isEditable, isSaving } = this.state;
        const saveBtnText = isSaving ? "Saving..." : "Save";
        let totalCalories = !_.isEmpty(mealItem) && !_.isEmpty(mealItem.nutritionInfo) && mealItem.nutritionInfo.calories !== undefined ? parseInt(mealItem.nutritionInfo.calories.toString()) + " kcal" : "";
        const combinedDishes: IMealComponent[] = !_.isEmpty(mealItem) && !_.isEmpty(mealItem.components) ? isEditable ? this.state.addedComponents : mealItem.components : [];
        return (
            <div className={"meal-item-editor"}>
                {
                    !_.isNull(this.state.meal) &&
                    <div>
                        <div className={"meal-item-left-subContainer"}>
                            <div className={"meal-name brandon-bold"}>
                                {mealItem.name}{!_.isEmpty(totalCalories) ? ` - ${totalCalories}` : ""}
                            </div>

                            <div className={"dishes-header brandon-bold"}>DISHES</div>
                            {
                                !_.isEmpty(combinedDishes) &&
                                <div className={"meal-item-components"}>
                                    {
                                        _.map(combinedDishes, (component, index) => {
                                            return <div className={"dish-component"} key={`meal-item-${index}`}>
                                                <div className={"name-label brandon-bold"}>{component.displayName}</div>
                                                <div>
                                                    {!isEditable && <span className={"dish-quantity"}>{component.quantity}</span>}
                                                    {isEditable && <TextInput name={component.dishId} value={component.quantity} onChange={(event: any) => this.editDishQuantity(event, component.dishId)}/>}
                                                    <span className={"dish-unit"}>{component.unit}</span>
                                                    {isEditable && <span className={"glyphicon glyphicon-remove"} onClick={() => this.removeDish(component.dishId)}/>}
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                            }
                            {isEditable && <div className={"meal-adder-container"}>
                                <DishAdder onDishAdd={this.addDish} fetchStaticDishes={this.props.fetchStaticDishes} suggestions={this.getSuggestions()}/>
                            </div>}
                        </div>
                        <div className={"meal-item-right-subContainer"}>
                            <div className={"cancel-meal-button-container"}>
                                {isEditable && <input className="card-primary-action" type="button" value={saveBtnText} onClick={this.handleSave} />}
                                {isEditable && <input className="card-primary-action" type="button" value={"Cancel"} onClick={this.handleCancel} />}
                                {!isEditable && <input className="card-primary-action" type="button" value={"Edit"} onClick={this.handleEdit} />}
                                <span className={"glyphicon glyphicon-remove"} onClick={this.removeMeal}></span>
                            </div>
                            {/*<div className={"accompaniments-container"}>
                                <div className={"accompaniements-header brandon-bold"}>ACCOMPANIMENTS IF ANY</div>
                                <TextInput name={"meal-accompaniements"}/>
                            </div>*/}
                        </div>
                    </div>
                }
                {
                    _.isNull(this.state.meal) &&
                    <div><AppLoader/></div>
                }
            </div>
        )
    }
}

export default MealItemEditor;